<template>
    <div class="box subscription-box">
        <p class="small-box-title">
            Payment Summary
            <span
                v-if="userSubscription && userSubscription.cancel_at_period_end"
                class="coupon-code"
            >
                cancelled
            </span>
        </p>
        <transition
            name="fade"
            mode="out-in"
        >
            <base-loader
                v-if="! subscriptionChecked || (userSubscription && null === billingSummary)"
            />
            <div
                v-else-if="! userSubscription || ! billingSummary"
                class="no-subscription"
            >
                <p>
                    You don’t have an active subscription.
                </p>
            </div>
            <div v-else>
                <div class="subscription-items">
                    <div
                        v-for="item in billingSummary"
                        :key="item.id"
                        class="subscription-item"
                    >
                        <div class="item-details">
                            <div class="item-name">
                                {{ item.name }}
                            </div>
                            <div class="item-quantity">
                                ({{ item.quantity }} {{ item.quantity > 1 ? 'Shows' : 'Show' }})
                            </div>
                        </div>
                        <div class="item-cost">
                            {{ formatCost(item.total) }}
                            <span class="item-cost-suffix">/ {{ formatInterval(item.interval) }}</span>
                        </div>
                    </div>
                </div>

                <div class="plan-change-box">
                    <template
                        v-if="! userSubscription.cancel_at_period_end"
                    >
                        <a
                            class="link"
                            href="#"
                            @click.prevent="openBillingChange"
                        >{{ isAnnual ? 'Change your billing plan' : 'Switch to Annual' }}</a>
                        <span v-if="! isAnnual">and Save 38%</span>
                    </template>
                    <a
                        v-else
                        class="link"
                        href="#"
                        @click.prevent="openResumeSubscriptionModal"
                    >
                        Resume Your Subscription
                    </a>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import {
    mapMutations,
    mapState,
} from 'vuex';
import usdFormatter from '@/utils/usdFormatter';

export default {
    computed: {
        ...mapState([
            'billingSummary',
            'subscriptionChecked',
            'userSubscription',
        ]),

        /**
         * @returns {boolean} If is annual plan.
         */
        isAnnual() {
            return 'year' === this.userSubscription?.interval;
        },
    },

    /**
     * Loads required data to store.
     */
    mounted() {
        this.$store.dispatch('loadUserSubscription');
        this.$store.dispatch('getBillingPlans');
        this.$store.dispatch('getBillingSummary');
    },

    methods: {
        ...mapMutations(['changeUIState']),

        /**
         * Opens upgrade modal
         */
        openBillingChange() {
            this.changeUIState({ isBillingPlanChangeVisible: true });
        },

        /**
         * Opens resume subscription modal
         */
        openResumeSubscriptionModal() {
            this.changeUIState({ isResumeSubscriptionModalVisible: true });
        },

        /**
         * Formats plan cost.
         *
         * @param   {string} cost Plan cost.
         * @returns {string}      Formatted plan cost.
         */
        formatCost(cost) {
            return usdFormatter(cost, { withFraction: false });
        },

        /**
         * Formats plan interval.
         *
         * @param  {string} interval  Plan interval name.
         * @returns {string}          Formatted plan interval name.`
         */
        formatInterval(interval) {
            const intervals = {
                month: 'mo',
            };

            return intervals[interval] || interval;
        },
    },
};
</script>
